import { SelectInput, TextInput, required } from 'react-admin';
import { GENDER_CHOICES, path } from '@/pages/Candidate/constants';
import { ProviderInput, StateInput } from '@/pages/Candidate/view/inputs';
import { DefaultToolbarStyled } from '@/styles/overrides';
import { TurnReferencesEnum } from '@/types/turn-enums';
import { RequestMVRProps } from '../types';
import { OVERRIDE_PROVIDER_HELPER_TEXT } from './constants';
import OverrideProviderConfirmDialog from './OverrideProviderConfirmDialog';
import { Container, Pair } from './styled';
import useController from './useController';

const FormContent = (props: RequestMVRProps) => {
  const {
    fieldDisabled,
    handleOverrideCancel,
    handleOverrideConfirm,
    handleOverrideProviderChange,
    handleRequest,
    overrideConfirm,
    requestAlwaysEnable,
    validateLicense,
  } = useController(props);

  return (
    <Container>
      <Pair>
        <TextInput disabled={fieldDisabled} source={path('first_name')} validate={required()} />
        <TextInput disabled={fieldDisabled} source={path('last_name')} validate={required()} />
      </Pair>
      <Pair>
        <TextInput disabled={fieldDisabled} label="DOB" source={path('date_of_birth')} />
        <SelectInput choices={GENDER_CHOICES} disabled={fieldDisabled} source={path('gender')} validate={required()} />
      </Pair>
      <Pair>
        <StateInput
          disabled={fieldDisabled}
          label="Driver License State"
          source={path('drivers_license_state')}
          validate={required()}
        />
        <TextInput
          disabled={fieldDisabled}
          label="Driver License Number"
          source={path('drivers_license_number')}
          validate={validateLicense}
        />
      </Pair>
      <Pair>
        <TextInput disabled={fieldDisabled} label="Default Provider" source={path('default_mvr_provider')} />
        <ProviderInput
          helperText={OVERRIDE_PROVIDER_HELPER_TEXT}
          label="Override Provider"
          onChange={handleOverrideProviderChange}
          reference={TurnReferencesEnum.AdminMVRProviders}
        />
      </Pair>

      <DefaultToolbarStyled
        alwaysEnable={requestAlwaysEnable}
        onClose={props.onClose}
        onSave={handleRequest}
        saveButtonLabel="Request"
      />

      <OverrideProviderConfirmDialog
        defaultProvider={overrideConfirm.defaultProvider}
        onCancel={handleOverrideCancel}
        onConfirm={handleOverrideConfirm}
        open={overrideConfirm.open}
        overrideProvider={overrideConfirm.overrideProvider}
        state={overrideConfirm.state}
      />
    </Container>
  );
};

export default FormContent;
